var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.464215 7.81588L6.22278 13.5292C6.62689 13.9373 7.23306 13.9373 7.63717 13.5292C8.04128 13.1211 8.04128 12.509 7.63717 12.1009L2.68682 6.99969L7.63717 1.89847C8.04128 1.49038 8.04128 0.878232 7.63717 0.470135C7.43511 0.266086 7.23306 0.164062 6.92997 0.164062C6.62689 0.164062 6.42484 0.266086 6.22278 0.470135L0.464215 6.18349C0.0601054 6.69361 0.0601054 7.30576 0.464215 7.81588C0.464215 7.71386 0.464215 7.71386 0.464215 7.81588Z",
    fill: "#6B47F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.738beea2d29350df4fc496997c575934.svg";
export { ForwardRef as ReactComponent };